import React from 'react';
import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import { fg } from '@atlaskit/platform-feature-flags';
import { SuggestTitleIcon } from '../../../../icons/prompt/suggestTitle';
import { createInsertAtCurrentPosition, createInsertAtTop, createReplaceExistingConfluenceTitle } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
export var suggestTitle = {
  key: CONFIG_ITEM_KEYS.SUGGEST_A_TITLE,
  title: aiConfigItemMessages.suggestTitleTitle,
  description: aiConfigItemMessages.suggestTitleDescription,
  icon: function icon() {
    return /*#__PURE__*/React.createElement(SuggestTitleIcon, null);
  },
  intentSchemaId: 'suggest_title_intent_schema.json',
  actions: {
    empty: [createInsertAtCurrentPosition({
      appearance: 'secondary'
    }), createInsertAtTop({
      appearance: 'primary'
    })],
    selection: [createInsertAtCurrentPosition({
      appearance: 'secondary'
    }), createInsertAtTop({
      appearance: 'primary'
    })]
  },
  getBackendModel: function getBackendModel() {
    if (fg('platform_editor_ai_assistance_service') || fg('platform_editor_ai_assistance_service_second')) {
      return 'assistance-service';
    }
    return 'xp-gen-ai';
  }
};
export var suggestTitleWithOptions = {
  config: suggestTitle,
  triggers: {
    empty: {
      enabled: true,
      docMinSize: 1
    },
    selection: {
      enabled: true
    }
  }
};

/**
 * EXPERIMENTAL: Util for experimental flow where 'Suggest title' in
 * Confluence title toolbar will trigger the 'Suggest a title' flow in Editor AI.
 */
export var suggestTitleForConfluenceTitleToolbar = {
  key: CONFIG_ITEM_KEYS.SUGGEST_A_TITLE,
  title: aiConfigItemMessages.suggestTitleTitle,
  description: aiConfigItemMessages.suggestTitleDescription,
  icon: function icon() {
    return /*#__PURE__*/React.createElement(SuggestTitleIcon, null);
  },
  intentSchemaId: 'suggest_title_intent_schema.json',
  actions: {
    empty: [createReplaceExistingConfluenceTitle({
      appearance: 'primary'
    })],
    selection: [createReplaceExistingConfluenceTitle({
      appearance: 'primary'
    })]
  },
  getBackendModel: function getBackendModel() {
    if (fg('platform_editor_ai_assistance_service') || fg('platform_editor_ai_assistance_service_second')) {
      return 'assistance-service';
    }
    return 'xp-gen-ai';
  }
};
export var suggestTitleForConfluenceTitleToolbarWithOptions = {
  config: suggestTitleForConfluenceTitleToolbar,
  triggers: {
    empty: {
      enabled: true,
      docMinSize: 1
    },
    selection: {
      enabled: true
    }
  }
};